import React from 'react';
import profilepic from './profilepic.jpg';
import './profilepicStyles.css';

const ProfilePicture = () => (
    <img src={profilepic} id="profile-picture" className="z-depth-5" alt="profile" />
);

export default ProfilePicture;